import { createFormAction } from "redux-form-saga";
export const PICKUP_ROUTE_FORM_KEY = "PICKUP_ROUTE_FORM_KEY";
export const PickupFormAction = createFormAction(PICKUP_ROUTE_FORM_KEY);

export const PICKUP_REGION_FORM_KEY = "PICKUP_REGION_FORM_KEY";
export const RegionFormAction = createFormAction(PICKUP_REGION_FORM_KEY);

export const STAFF_ROUTE_FORM_KEY = "STAFF_ROUTE_FORM_KEY";
export const StaffFormAction = createFormAction(STAFF_ROUTE_FORM_KEY);